import { unknownValue } from "@/shared/utils/formaters/unknownValue/unknownValue";

export function getLocale(): string {
  return window.navigator.language;
}

export function maybe(something?: any, formatter?: (s: any) => any, fallback?: string): string {
  return something ? (formatter ? formatter(something) : something) : unknownValue(fallback);
}
